import React, { useState } from "react";
import { Card, Form } from "react-bootstrap";
import ErrorComponent from "../../../Components/ErrorMessage";
import { replacePlaceholder } from "../../../Utils/Utils";
function MultiTextQuestion({ question, handleChange, formValues, showError }) {
  // Initialize from formValues[question.tempId] or create empty object
  const initialValues = formValues[question.tempId] || 
    question.choices?.reduce((acc, choice) => {
      acc[choice.value] = '';
      return acc;
    }, {}) || {};

  const [values, setValues] = useState(initialValues);
  const [validations, setValidations] = useState({});

  const handleTextChange = (key, event) => {
    const value = event.target.value;
    const isValid = value.length <= 1024;
    
    const newValues = { ...values, [key]: value };
    setValues(newValues);
    setValidations(prev => ({ ...prev, [key]: isValid }));
    
    // Update the entire object in form state
    handleChange({
      target: {
        name: question.tempId,
        value: newValues
      }
    });
  };

   const hasAllAnswers = question.choices?.every(choice => {
    if (!question.isMandatory) return true;
 const val = values[choice.value];
  return typeof val === "string" && val.trim() !== "";
  });

  const questionText = replacePlaceholder(question.questionText, formValues);

  return (
    <Card className={`mt-3 ${question.isMandatory && showError && !hasAllAnswers ? "border-danger" : ""}`}>
      <Card.Body>
        <Form.Group>
          <div className="d-flex flex-column">
            <Form.Label>
              <b style={{whiteSpace: 'pre-wrap',wordBreak: 'break-word'}}>
                {question.tempId}.{questionText}
                {question.isMandatory && <span className="text-danger">*</span>}
              </b>
            </Form.Label>
            <Form.Label>
              <b style={{ color: 'lightblue' }}>{question.questionDescription}</b>
            </Form.Label>
          </div>

          {question.choices?.map((choice) => (
            <div key={choice.tempId} className="mb-3">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <Form.Label className="fw-bold mb-0">{choice.text}</Form.Label>
                </div>
                <div className="col-md-8">
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={values[choice.value] || ''}
                    onChange={(e) => handleTextChange(choice.value, e)}
                    required={question.isMandatory}
                    placeholder={question.placeHolderText || "Type Here..."}
                  />
                  {question.isMandatory && showError && !values[choice.value] && (
                    <div className="text-danger small mt-1">
                      {`${choice.text} is required`}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}

          {question.isMandatory && showError && !hasAllAnswers && (
            <div className="text-danger mt-2">
              <ErrorComponent message={question.requiredErrorText} />
            </div>
          )}
        </Form.Group>
      </Card.Body>
    </Card>
  );
}

export default MultiTextQuestion;